<template>
    <div class="col-md-12 flex-container">
        <div class="w-100">
            <div class="col-md-12">
                <div class="h2">Test page</div>
                <div class="row my-3">
                    <div class="col-md-4 pl-0">
                        <div class="form-group">
                            <div class="col-md-12">
                                <label class="d-block mb-0 font-weight-bold">Scan barcode</label>
                                <stream-barcode-reader @decode="onDecode" @loaded="onLoaded"></stream-barcode-reader>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div v-for="colli in collis">{{ colli }}</div>
                    <div>
                        <button type="button" class="btn btn-success" @click="collis = []">
                            Clear barcodes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import StreamBarcodeReader from "../vue-barcode-reader/StreamBarcodeReader.vue";

export default {
    name: "Testpage",
    props: {},
    components: {StreamBarcodeReader},
    data() {
        return {
            collis: [],
            barcode: ''
        }
    },
    methods: {
        onScanBarcode() {
            setTimeout(() => {
                if (this.barcode) {
                    this.collis.push(this.barcode);
                }
            }, 500);
        },

        onDecode(value) {
            console.log(value);
            this.barcode = value;
            this.onScanBarcode();
        },
        onLoaded() {
            console.log('StreamBarcodeReader is loaded');
        },
    },
    created() {
    },
}
</script>
<style>
</style>
